import React from "react";
import Breadcrumb from "antd/es/breadcrumb";
import { Typography, theme } from "antd";
import { ProCard } from "@ant-design/pro-components";
import Card from "antd/es/card/Card";
import { ItemType } from "antd/es/breadcrumb/Breadcrumb";

import clsx from "clsx";
import styles from "./index.module.scss";
import StickyBar from "../StickyBar";

interface SinglePageContainer extends React.PropsWithChildren {
  breadcrumbItems?: ItemType[];
  title: React.ReactNode;
  extra?: React.ReactNode;
  cardLoading?: boolean;
  className?: string;
  style?: React.CSSProperties;
  stickyHeader?: boolean;
}

export default function SinglePageContainer({
  breadcrumbItems = [],
  title,
  cardLoading = false,
  extra = undefined,
  children,
  className = "",
  style,
  stickyHeader = false,
}: SinglePageContainer) {
  const {
    token: { colorBgLayout },
  } = theme.useToken();

  return (
    <div className="transparent">
      {breadcrumbItems.length > 0 ? (
        <Breadcrumb
          className="page-header-breadcrumb"
          items={breadcrumbItems}
        />
      ) : null}

      {stickyHeader ? (
        // Sticky, so it carries the shadow every sticky bar in the app carries:
        // shown only once content has actually scrolled under it.
        <StickyBar
          className={styles.heading}
          style={{ backgroundColor: colorBgLayout }}
        >
          <Typography.Title level={4} className={styles.pageTitle}>
            {title}
          </Typography.Title>
          <div className={clsx("flex-row-wrapper", styles.extra)}>{extra}</div>
        </StickyBar>
      ) : (
        <div className={styles.heading}>
          <Typography.Title level={4} className={styles.pageTitle}>
            {title}
          </Typography.Title>
          <div className={clsx("flex-row-wrapper", styles.extra)}>{extra}</div>
        </div>
      )}

      {/* styles={{ body: { padding: '16px' } }} */}
      <ProCard loading={cardLoading} className={className} style={style}>
        {children}
      </ProCard>
    </div>
  );
}
